import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import OutputText from '@ey/canvascoreservices/OutputText';

import StyledCountDropdownColumn from './StyledCountDropdownColumn';
import Button from '../../../CoreWrappers/Button';
import Dropdown from '../../../CoreWrappers/Dropdown';

const CountDropdownColumn = ({list, customRender = null}) => {
	const [firstItem, ...rest] = list;

	const renderItem = (value, index = 0, isFirst = false) => {
		if (customRender) return customRender(value, index, isFirst);

		const props = {
			key: index,
			title: value,
			onClick: () => {
				debugger;
			}
		};
		if (isFirst) {
			props.body2 = true;
			props.light = true;
		} else {
			props.maxWidth = 'var(--px-200)';
			props.useTypography = false;
		}

		return (
			<OutputText body2 light ellipsis {...props}>
				{value}
			</OutputText>
		);
	};

	const renderTrigger = () => {
		const text = `+${rest.length}`;
		const props = {
			variant: 'text-alt',
			size: 'small'
		};

		return <Button {...props}>{text}</Button>;
	};

	const renderDropdown = () => {
		const items = rest.map((item, index) => ({
			id: index,
			label: item,
			type: 'container',
			customRender: () => renderItem(item, index)
		}));

		const props = {
			placement: 'bottom-right',
			trigger: renderTrigger(),
			items,
			topfix: true,
			reversed: true,
			maxItems: 5,
			itemSize: 44
		};

		return <Dropdown {...props} />;
	};

	return (
		<StyledCountDropdownColumn>
			{renderItem(firstItem, 'firstItem', true)}
			{rest.length > 0 && renderDropdown()}
		</StyledCountDropdownColumn>
	);
};

CountDropdownColumn.propTypes = {
	customRemder: PropTypes.func
};

CountDropdownColumn.defaultProps = {
	customRender: null
};

export default CountDropdownColumn;
